import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { UserAuth } from '../models/user.auth.model';
import { UtilService } from './util.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class SeguridadService {
  private _obsUser: BehaviorSubject<UserAuth> = new BehaviorSubject<UserAuth>(
    {} as UserAuth
  );

  public user$ = this._obsUser.asObservable();

  private urlServiceAdmin = environment.API_SERVICES_ADMIN;
  private urlBaseSecurity = environment.API_SERVICES_SECURITY;
  urlAuth = `${this.urlServiceAdmin}/auth/login`;
  urlSecurity = `${this.urlBaseSecurity}/api/admin/security`;
  url = `${this.urlServiceAdmin}/api`;

  subSessionRefresh!: Subscription;

  constructor(
    public utilService: UtilService,
    private jwtHelper: JwtHelperService,
    private http: HttpClient
  ) {}

  refreshSessionData(): void {
    if (!this.getToken()) {
      return;
    }
    const token = this.getToken();
    if (token && token !== '') {
      this.setToken(environment.VAR_TOKEN, token);
    }
  }

  refreshSessionToken() {
    if (!this.getToken()) {
      return;
    }
  }

  setToken(tokenName: string, token?: string) {
    if (token) {
      this.setUser(token);
    }
    return this.utilService.setSessionStorage(tokenName, token);
  }

  getToken() {
    return this.utilService.getSessionStorage(environment.VAR_TOKEN);
  }

  setUser(token: string): void {
    const payloadUser = this.jwtHelper.decodeToken(token);
    let user = payloadUser;
    this._obsUser.next(user);
    this.utilService.setSessionStorage(
      environment.VAR_USER,
      JSON.stringify(user)
    );
  }

  getUser(): UserAuth {
    const user = this.utilService.getSessionStorage(environment.VAR_USER);
    return JSON.parse(user);
  }

  getObsUser(): Observable<UserAuth> {
    return this._obsUser.asObservable();
  }

  public isAuthenticated(): boolean {
    const token = this.utilService.getSessionStorage(environment.VAR_TOKEN);
    return !this.jwtHelper.isTokenExpired(token);
  }

  existsRole(): boolean {
    const token = this.getToken();
    let roles: string[] = [];
    if (token && token !== '') {
      const tokenPayload = this.jwtHelper.decodeToken(token);
      const userInfoJSON = JSON.parse(tokenPayload.userInfo);
      const user = Object.assign({} as UserAuth, userInfoJSON);
      roles = user.roles;
    }
    return roles.length === 0;
  }

  logout(): void {
    this.clearLocalStorage();
  }

  clearLocalStorage(): void {
    this.utilService.removeSessionStorage(environment.VAR_TOKEN);
    this.utilService.removeSessionStorage(environment.VAR_USER);
  }

  postAuthenticationUser(request: any) {
    return this.http.post<any>(`${this.urlAuth}`, request);
  }

  postCreateUserAlertEarly(request: any) {
    return this.http.post<any>(`${this.url}/alert-user/early-alert`, request);
  }

  postCreateUserAlertEarlyGoogle(request: any) {
    return this.http.post<any>(
      `${this.url}/alert-user/early-alert-google`,
      request
    );
  }

  postLoginGoogle(request: any) {
    return this.http.post<any>(`${this.urlAuth}-google`, request);
  }
}
